import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
const FB_PIXEL_ID = '1545009850674181';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // No cargar el Pixel dentro del preview (iframe): el script externo de
    // Facebook genera un "Script error." cross-origin en el entorno sandbox.
    // En el sitio publicado la app corre top-level y el Pixel se dispara normal.
    let isTopLevel = true;
    try {
      isTopLevel = window.self === window.top;
    } catch {
      isTopLevel = false;
    }
    if (!isTopLevel) return;
    try {
      // Evitar doble inicialización
      if ((window as any).fbq) {
        ;
        (window as any).fbq('track', 'PageView');
        return;
      }
      /* Meta Pixel base code */
      ;
      (function (f: any, b, e, v, n?: any, t?: any, s?: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', FB_PIXEL_ID);
      (window as any).fbq('track', 'PageView');
    } catch (e) {
      // El Pixel nunca debe romper la página
      console.warn('Meta Pixel init skipped:', e);
    }
  }, []);
  return <LandingPage data-id="element-0" />;
}